import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e056b3ac&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e056b3ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e056b3ac')) {
      api.createRecord('e056b3ac', component.options)
    } else {
      api.reload('e056b3ac', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e056b3ac&scoped=true", function () {
      api.rerender('e056b3ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/qualityService/signLimitConfiguration/index.vue"
export default component.exports